<p-blockui [blocked]="state.blocked()">
  <div class="flex items-center justify-center h-full w-full">
    <p-progress-spinner ariaLabel="loading" />
  </div>
</p-blockui>
